import React from 'react';
import { Smartphone, Zap, Shield, Layout, Cpu, Repeat } from 'lucide-react';
import './SaaSDevelopment.css';

const MobileApps = () => {
  return (
    <div className="saas-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <span className="eyebrow">Mobile Development</span>
            <h1>Native & Cross-Platform Mobile Solutions</h1>
            <p>
              Engage your users anywhere with high-performance mobile applications that 
              deliver seamless experiences across iOS and Android.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Build My App</a>
              <a className="button secondary" href="#technologies">View Platforms</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow">
              <Smartphone className="icon" />
              <h3>Native Performance</h3>
              <p>Optmized for every device with smooth animations and deep hardware integration.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="technologies" className="section">
        <div className="section-heading">
          <span className="eyebrow">What We Build</span>
          <h2>A mobile strategy for the modern era.</h2>
          <p>We specialize in Flutter and React Native to provide the perfect balance of performance and development speed.</p>
        </div>

        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="cap-icon"><Layout size={24} /></div>
            <h3>Cross-Platform Swiftly</h3>
            <p>Develop once for both iOS and Android without compromising on the native feel.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Zap size={24} /></div>
            <h3>Snappy Interactions</h3>
            <p>60 FPS performance ensuring every touch and swipe feels instantaneous.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Shield size={24} /></div>
            <h3>Biometric Security</h3>
            <p>Secure login with Face ID, Fingerprint, and advanced encryption methods.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Cpu size={24} /></div>
            <h3>Hardware Access</h3>
            <p>Full integration with Camera, GPS, Bluetooth, and local storage.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="solutions-container">
          <div className="solution-row reverse">
            <div className="solution-copy">
              <h3>Enterprise Grade Synchronization</h3>
              <p>
                Our mobile apps are built to work offline and sync perfectly when 
                connectivity returns, ensuring no data is ever lost.
              </p>
              <ul className="feature-list">
                <li><Repeat size={18} /> Offline-First Architecture</li>
                <li><Repeat size={18} /> Background Tasks</li>
                <li><Repeat size={18} /> Push Notifications</li>
              </ul>
            </div>
            <div className="solution-media">
               <div className="panel-card panel-gradient">
                <Smartphone size={64} className="icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid">
        <div className="metric-item">
          <strong>4.8/5</strong>
          <span>Avg App Store Rating</span>
        </div>
        <div className="metric-item">
          <strong>2x</strong>
          <span>Faster Deployment</span>
        </div>
        <div className="metric-item">
          <strong>99.9%</strong>
          <span>Crash-Free Sessions</span>
        </div>
        <div className="metric-item">
          <strong>iOS/Android</strong>
          <span>Full Support</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Have an app idea?</h2>
          <p>Let us turn your vision into a chart-topping mobile reality.</p>
          <a className="button primary" href="#contact">Star Development</a>
        </div>
      </section>
    </div>
  );
};

export default MobileApps;
